import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import Breadcrumbs from "../../components/Common/Breadcrumb"
import {
  Button,
  Spinner,
  UncontrolledTooltip,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Media,
  Collapse,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import { Link } from "react-router-dom"
import GeneralSettings from "./GeneralSettings"
import StoreDetails from "./StoreDetails"
import HolidayCalendar from "./HolidayCalendar"
import classnames from "classnames"
import { clearLocalCache } from "helpers/cache_helper";
import { showSuccessToast } from "helpers/function_helper"

const SettingsHome = props => {

  const [customActiveTab, setcustomActiveTab] = useState("1")

  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab)
    }
  }

  async function clearAllCache(){
    await clearLocalCache()
    showSuccessToast('Cache cleared successfully!')
  }

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Settings | Flamingo</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs title="Settings" breadcrumbItem="Settings Home" /> 
            <Nav tabs className="nav-tabs-custom nav-justified">
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: customActiveTab === "1",
                  })}
                  onClick={() => {
                    toggleCustom("1")
                  }}
                >
                  <span className=" ">Store Details</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: customActiveTab === "2",
                  })}
                  onClick={() => {
                    toggleCustom("2")
                  }}
                >
                  <span className=" ">General</span>
                </NavLink>
              </NavItem>
              <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: customActiveTab === "3",
                    })}
                    onClick={() => {
                      toggleCustom("3")
                    }}
                  >
                    <span className=" ">Product / Item</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: customActiveTab === "4",
                    })}
                    onClick={() => {
                      toggleCustom("4")
                    }}
                  >
                    <span className=" ">Holidays</span>
                  </NavLink>
                </NavItem>
            </Nav>
            <TabContent
              activeTab={customActiveTab}
              className="p-3 text-muted"
            >
              <TabPane tabId="1">
                <StoreDetails/>
              </TabPane>
              <TabPane tabId="2">
                <GeneralSettings/>
              </TabPane>
              <TabPane tabId="3">
                <Row>
                  <Col sm="2">
                    <Link to="/list-hsn">
                      <Card>
                        <CardBody>
                          <div className="d-flex align-items-center text-center">
                            <div className="avatar-sm ">
                              <span className="avatar-title rounded-circle bg-light text-danger font-size-14">
                                <i className="bx bx-door-open font-size-20"></i>
                              </span>
                            </div>
                            <div className="flex-grow-1 overflow-hidden">
                              <span className="font-size-14 ">HSN</span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Link>
                  </Col>
                  <Col sm="2">
                    <Link to="/list-unit">
                      <Card>
                        <CardBody>
                          <div className="d-flex align-items-center text-center">
                            <div className="avatar-sm ">
                              <span className="avatar-title rounded-circle bg-light text-danger font-size-14">
                                <i className="fas fa-balance-scale font-size-20"></i>
                              </span>
                            </div>
                            <div className="flex-grow-1 overflow-hidden">
                              <span className="font-size-14 ">Unit</span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Link>
                  </Col>
                  <Col sm="2">
                    <Link to="/list-tax">
                      <Card>
                        <CardBody>
                          <div className="d-flex align-items-center text-center">
                            <div className="avatar-sm ">
                              <span className="avatar-title rounded-circle bg-light text-danger font-size-14">
                                <i className="fas fa-puzzle-piece font-size-20"></i>
                              </span>
                            </div>
                            <div className="flex-grow-1 overflow-hidden">
                              <span className="font-size-14 ">Tax</span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Link>
                  </Col>
                  <Col sm="2">
                    <Link to="/list-size">
                      <Card>
                        <CardBody>
                          <div className="d-flex align-items-center text-center">
                            <div className="avatar-sm ">
                              <span className="avatar-title rounded-circle bg-light text-danger font-size-14">
                                <i className="fas fa-shapes font-size-20"></i>
                              </span>
                            </div>
                            <div className="flex-grow-1 overflow-hidden">
                              <span className="font-size-14 ">Size</span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Link>
                  </Col>
                  <Col sm="2">
                    <Link to="/list-brand">
                      <Card>
                        <CardBody>
                          <div className="d-flex align-items-center text-center">
                            <div className="avatar-sm ">
                              <span className="avatar-title rounded-circle bg-light text-danger font-size-14">
                                <i className="fas fa-cog font-size-20"></i>
                              </span>
                            </div>
                            <div className="flex-grow-1 overflow-hidden">
                              <span className="font-size-14 ">Brand</span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Link>
                  </Col>
                  <Col sm="2">
                    <Link to="/list-colour">
                      <Card>
                        <CardBody>
                          <div className="d-flex align-items-center text-center">
                            <div className="avatar-sm ">
                              <span className="avatar-title rounded-circle bg-light text-danger font-size-14">
                                <i className="fas fa-th-large font-size-20"></i>
                              </span>
                            </div>
                            <div className="flex-grow-1 overflow-hidden">
                              <span className="font-size-14 ">Colour</span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Link>
                  </Col>
                </Row>
                <Row>
                  <Col sm="3">
                    <Link to="/list-category-subcategory">
                      <Card>
                        <CardBody>
                          <div className="d-flex align-items-center text-center">
                            <div className="avatar-sm ">
                              <span className="avatar-title rounded-circle bg-light text-danger font-size-14">
                                <i className="fas fa-list-ul font-size-20"></i>
                              </span>
                            </div>
                            <div className="flex-grow-1 overflow-hidden">
                              <span className="font-size-14 ">Category & Sub-Category</span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Link>
                  </Col>
                  <Col sm="3">
                    <Link to="/list-manufacturer">
                      <Card>
                        <CardBody>
                          <div className="d-flex align-items-center text-center">
                            <div className="avatar-sm ">
                              <span className="avatar-title rounded-circle bg-light text-danger font-size-14">
                                <i className="fas fa-dice-d20 font-size-20"></i>
                              </span>
                            </div>
                            <div className="flex-grow-1 overflow-hidden">
                              <span className="font-size-14 ">Manufacturer</span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Link>
                  </Col>
                  

                  <Col sm="2">
                    <Link to="/list-customer">
                      <Card>
                        <CardBody>
                          <div className="d-flex align-items-center text-center">
                            <div className="avatar-sm ">
                              <span className="avatar-title rounded-circle bg-light text-danger font-size-14">
                                <i className="fas fa-user-friends font-size-20"></i>
                              </span>
                            </div>
                            <div className="flex-grow-1 overflow-hidden">
                              <span className="font-size-14 ">Customer</span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Link>
                  </Col>
                  <Col sm="2">
                    <Link to="/list-supplier">
                      <Card>
                        <CardBody>
                          <div className="d-flex align-items-center text-center">
                            <div className="avatar-sm ">
                              <span className="avatar-title rounded-circle bg-light text-danger font-size-14">
                                <i className="fas fa-shipping-fast font-size-20"></i>
                              </span>
                            </div>
                            <div className="flex-grow-1 overflow-hidden">
                              <span className="font-size-14 ">Supplier</span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Link>
                  </Col>
                </Row>

                <Row>
                  <Col sm="2">
                    <Card className="bg-warning pointer-cursor-with-hover" onClick={()=>clearAllCache()}>
                      <CardBody>
                        <div className="d-flex align-items-center text-center">
                          <div className="avatar-sm ">
                            <span className="avatar-title rounded-circle bg-light text-danger font-size-14">
                              <i className="fas fa-star-of-life font-size-20"></i>
                            </span>
                          </div>
                          <div className="flex-grow-1 overflow-hidden">
                            <span className="font-size-14 ">Clear Local Cache</span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>

              </TabPane>
              <TabPane tabId="4">
                <HolidayCalendar/>
              </TabPane>
            </TabContent>
          </Container>
        </div>
      </React.Fragment>
    )
}
export default SettingsHome;
